import { render } from "./ArticleRating.vue?vue&type=template&id=42e12871&scoped=true"
import script from "./ArticleRating.vue?vue&type=script&lang=js"
export * from "./ArticleRating.vue?vue&type=script&lang=js"

import "./ArticleRating.vue?vue&type=style&index=0&id=42e12871&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e12871"]])

export default __exports__